export default {
  queryOrderDetail: '/gateway/capp/mallcenter/ordercenter/queryOrderDetail',
  confirmSign: '/gateway/capp/mallcenter/ordercenter/confirmSignfor'
}
